var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestaurant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.03 61.243a1 1 0 0 0 .97.757h42a1 1 0 0 0 .97-.757l1-4a1 1 0 0 0 -.97-1.243h-1.051a21.012 21.012 0 0 0 -16.989-19.613c.012-.13.04-.257.04-.387a4 4 0 0 0 -8 0c0 .13.028.257.04.387a21.012 21.012 0 0 0 -16.989 19.613h-1.051a1 1 0 0 0 -.97 1.243zm42.189-1.243h-40.438l-.5-2h41.438zm-22.219-24a2 2 0 0 1 4 0c0 .034-.009.067-.01.1-.656-.062-1.318-.1-1.99-.1s-1.334.039-1.99.1c-.001-.033-.01-.066-.01-.1zm2 2a19.007 19.007 0 0 1 18.949 18h-37.898a19.007 19.007 0 0 1 18.949-18z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10.275 48.5 1.731 1a15.029 15.029 0 0 1 16.744-7.028l.5-1.936a17.026 17.026 0 0 0 -18.975 7.964z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m8.536 52.75 1.936.5a14.9 14.9 0 0 1 .618-1.875l-1.854-.75a17.041 17.041 0 0 0 -.7 2.125z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m61 7h-3v-4a1 1 0 0 0 -1.154-.988l-32 5v.019a.986.986 0 0 0 -.846.969v22h2v-21h34v51h-11v2h12a1 1 0 0 0 1-1v-53a1 1 0 0 0 -1-1zm-5 0h-18.123l18.123-2.832z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m33.808 19.778-2.829-2.828-1.414 1.414 2.829 2.828a5 5 0 0 0 6.292.636l2.9 2.9-9.192 9.192 1.414 1.414 9.192-9.192 9.192 9.192 1.414-1.414-9.192-9.192 1.486-1.486a5.005 5.005 0 0 0 6.292-.636l1.414-1.414a5 5 0 1 0 -7.07-7.07l-1.414 1.414a5 5 0 0 0 -.636 6.292l-1.486 1.486-2.9-2.9a5 5 0 0 0 -.636-6.292l-2.828-2.829-1.414 1.414 2.828 2.829a3 3 0 0 1 .577 3.4l-4.819-4.819-1.414 1.414 4.819 4.819a3 3 0 0 1 -3.405-.572zm12.728-2.828 1.414-1.414a3 3 0 0 1 4.242 4.242l-1.414 1.414a3 3 0 1 1 -4.242-4.242z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m55 38h2v2h-2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m55 42h2v2h-2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m55 46h2v2h-2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m40 38h13v2h-13z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m44 42h9v2h-9z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m47 46h6v2h-6z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m20 10h2v18h-2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurant);
export default __webpack_public_path__ + "static/media/restaurant.03352cf5fc47adcc7b0eff23722803b9.svg";
export { ForwardRef as ReactComponent };